// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"671":"002cd77eab668651","851":"74e1e98e093582fb"}[chunkId] + ".js";
};